import React from "react";
import { Calendar, Share2 } from "lucide-react";

const HeaderBar = ({ lastUpdated }) => {
  return (
    <header className="bg-white border-b border-slate-200 h-16 px-8 flex items-center justify-between shadow-sm z-10">
      {/* Left: Breadcrumbs/Context */}
      <div className="flex items-center gap-3">
        {/* Rebranded Badge */}
        <span className="bg-slate-100 text-slate-600 px-2 py-1 rounded text-xs font-bold tracking-wide border border-slate-200">
          RESOURCE HUB
        </span>
        <span className="text-slate-400 text-sm">/</span>
        <span className="font-semibold text-slate-700">
          Lifecycle Strategy & Best Practices
        </span>
      </div>

      {/* Right: Meta Info */}
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2 text-slate-500 text-sm">
          <Calendar size={16} />
          <span>Latest Update: {lastUpdated}</span>
        </div>
        <button className="text-emerald-600 hover:text-emerald-800 flex items-center gap-2 text-sm font-medium">
          <Share2 size={16} /> Share Resource
        </button>
      </div>
    </header>
  );
};

export default HeaderBar;
